import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ThemeService } from '@core/theme/theme.service';

/** Dark/light switch. Styled entirely by .theme-switch / .theme-toggle in _components.scss. */
@Component({
  selector: 'app-theme-toggle',
  host: { class: 'theme-switch' },
  template: `
    <span class="theme-icon" aria-hidden="true">{{ theme.isLight() ? '☀' : '☾' }}</span>
    <button
      type="button"
      class="theme-toggle"
      [attr.aria-pressed]="theme.isLight()"
      aria-label="Toggle light theme"
      (click)="theme.toggle()"
    ></button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeToggle {
  protected readonly theme = inject(ThemeService);
}
